import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/modules/material.module';

export type UnsavedChangesDialogResult = 'goBack' | 'discard' | 'saveDraft';

@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [MaterialModule],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesDialogComponent {
  dialogRef = inject(MatDialogRef<UnsavedChangesDialogComponent, UnsavedChangesDialogResult>);

  goBack(): void {
    this.dialogRef.close('goBack');
  }

  discardChanges(): void {
    this.dialogRef.close('discard');
  }

  saveDraft(): void {
    this.dialogRef.close('saveDraft');
  }
}
